import axios from "axios";
import React, { useCallback } from "react";

import { Form, Formik } from "formik";
// import "react-phone-input-2/lib/material.css";
import { useDispatch, useSelector } from "react-redux";

import { useLocalStorage } from "../../hooks";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import * as schoolActions from "../../redux/reducers/schoolReducer";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";


import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { useGoogleLogin } from "@react-oauth/google";
import lock_img from "../../assets/password.svg";
import BZLogo from "../../components/BZLogo";
import { TwButton, TwInputGroup, TwMainLayout, TwPhoneInputGroup } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import I18nLanguageDropdown from "../../components/I18nLanguageDropdown";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function SignIn({ }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const [passwordVisible, setPasswordVisible] = React.useState(false);

  const onLoginStart = useCallback(() => { }, []);
  const onLogin = async (body, values = null, setSubmitting = () => { }) => {
    dispatch(setActionLoading(true));
    const config = {
      method: "post",
      url: `${getUrlForUsers()}loginUser`,
      data: body,
    };
    try {
      const request = await axios(config);
      dispatch(setActionLoading(false));
      if (request.status === 200) {
        if (request.data.statusCode !== 200) {
          addErrorToast(request.data.message);
          setSubmitting(false);
        } else {
          setUserToken(request.data.data.token);
          dispatch(userActions.setUserData(request.data.data));
          dispatch(userActions.setBusinessType(request.data.data?.businessType || ""));
          if (values) {
            dispatch(
              userActions.setUserPhone(values.formattedPhoneNumber)
            );
          }
          let userData = request.data.data

          if (userData.onBoardingStep === 0) {
            if (userData.isVerified == true) {
              delete userData._id;
              dispatch(userActions.setOnBoardingData(
                {
                  ...userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : {},
                  ...userData,
                  name: userData.fullName,
                  sentFromSignupComplete: true,
                  from: "list",
                },
              ));
              navigate("/on-bording", { /** new on-bording **/
                state: {
                  from: "list",
                  // ...location.state,
                  ...userData,
                  name: userData.fullName,
                  sentFromSignupComplete: true,
                },
              })
            } else {
              // await Logout("");
              navigate("/");
            }
          } else if (userData.onBoardingStep === 1) {
            dispatch(userActions.setOnBoardingData(
              {
                ...userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : {},
                ...userData,
                name: userData.fullName,
                sentFromSignupComplete: true,
              },
            ));
            navigate("/on-bording", { /** new on-bording **/
              state: {
                ...userData,
                sentFromSignupComplete: true,
                name: userData.fullName,
                // socialType: location.state.socialType,
                // username: location.state.username,
              },
            })
          } else if (userData.onBoardingStep === 2) {
            dispatch(userActions.setOnBoardingData(
              {
                ...userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : {},
                ...userData,
                name: userData.fullName,
              },
            ));
            dispatch(userActions.setUserData(userData));
            dispatch(userActions.setBusinessType(userData.businessType));
            // let nextUrl = "/businessprofilesetup/subscription"
            // let nextUrl = "/businessprofilesetup/done"
            let nextUrl = "/my-subscription" /** new on-bording **/
            navigate(nextUrl, {
              state: {
                ...userData,
                // from: "registration", //for /businessprofilesetup/done and myresource/add
                from: "onbording",
                sentFromVerifyEmail: true,
                address: {}
              },
            })
          } else if (userData.onBoardingStep === 3) {
            dispatch(
              schoolActions.setCategories(
                request.data.data.seletedCategories
              )
            );
            setSubmitting(false);
            dispatch(dashboardActions.setCalendarOpen(false));
            navigate("/home/dashboard");
          } else {
            addSuccessToast(t("login.errorRequiredOnBording"), { hideAfter: 3 });
            setSubmitting(false);
            // navigate("/schoolprofilesetup", {
            navigate("/on-bording", { /** new on-bording **/
              state: {
                ...userData,
                sentFromSignupComplete: true,
                name: userData.fullName,
                // socialType: location.state.socialType,
                // username: location.state.username,
              },
            });
          }
          setSubmitting(false);
        }
      }
    } catch (error) {
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const userInfo = await axios.get(
        'https://www.googleapis.com/oauth2/v3/userinfo',
        { headers: { Authorization: `Bearer ${tokenResponse.access_token}` } },
      );

      const body = {
        username: userInfo.data.email,
        password: "",
        appToken: "k4zJNUAAv9eGQbZXuZf0SPMnuhr6vXfl",
        deviceType: "Web",
        userType: "teacher",
        socialType: 'google',
        socialToken: tokenResponse.access_token,
        socialData: {
          ...JSON.parse(JSON.stringify({
            ...userInfo.data,
            ...tokenResponse,
            provider: 'google',
          })),
        },
      };

      await onLogin(body);
    },
    onError: errorResponse => console.log(errorResponse),
  });

  React.useEffect(() => {
    if (userToken !== undefined && userToken !== "" && userReduxState.userData?.fullName) {
      window.location.href = "/home/dashboard";
    }
    dispatch(setActionLoading(false));
  }, []);


  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <div className="min-h-screen bg-white flex flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="fixed top-5 right-5">
          <I18nLanguageDropdown />
        </div>
        <div className="sm:mx-auto sm:w-full sm:max-w-md flex flex-col gap-5">
          <BZLogo className="mx-auto" />
          {!userToken && (<div className={"flex flex-col justify-center items-center gap-5 md:gap-8"}>
            <h2 className="text-center text-2xl md:text-3xl font-bold tracking-tight">
              {t("authentication.loginTitle")}
            </h2>
          </div>)}
        </div>

        {!userToken && (<div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <Formik
            initialValues={{
              countryName: "nl",
              countryCode: "",
              phone: "",
              formattedPhoneNumber: "",
              password: "",
            }}
            validate={(values) => {
              const errors = {};
              if (!values.phone) {
                errors.phone = t("errors.required");
              }
              if (!values.password) {
                errors.password = t("errors.required");
              }
              return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {
              let phoneNumber = values.formattedPhoneNumber.split(" ");
              phoneNumber = phoneNumber.join("");
              phoneNumber = phoneNumber.replace(" ", "");
              phoneNumber = phoneNumber.replace("-", "");
              setSubmitting(false);
              const body = {
                username: phoneNumber,
                password: values.password,
                appToken: "k4zJNUAAv9eGQbZXuZf0SPMnuhr6vXfl",
                deviceType: "Web",
                userType: "teacher",
              };

              await onLogin(body, values, setSubmitting);


            }}
          >
            {({
              values,
              setFieldValue,
              errors,
              touched,
              handleBlur,
              submitForm,
              isSubmitting,
            }) => (
              <Form onSubmit={(e) => {
                e.preventDefault();
                submitForm();
                return false;
              }} className="space-y-6">
                <div className={"flex flex-col gap-4"}>
                  <TwPhoneInputGroup
                    label={t("inputFieldsTitle.mobileNumber")}
                    placeholder={t("inputFieldsTitle.mobileNumber")}
                    name={"phone"}
                    country={values.countryName}
                    onBlur={() => handleBlur("phone")}
                    onChange={(phone, country, e) => {
                      const numberWithoutDialCode = phone.split("");
                      for (let i = 0; i < country.dialCode.length; i++) {
                        numberWithoutDialCode.shift();
                      }
                      setFieldValue("countryName", country.countryCode);
                      setFieldValue("countryCode", country.dialCode);
                      setFieldValue("phone", numberWithoutDialCode.join(""));
                      setFieldValue("formattedPhoneNumber", e.target.value);
                    }}
                    errors={touched["phone"] ? errors : {}}
                  />
                  <TwInputGroup
                    label={t("inputFieldsTitle.password")}
                    placeholder={t("inputFieldsTitle.passwordPlaceholder")}
                    name={"password"}
                    type={passwordVisible ? "text" : "password"}
                    leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                    rightIcon={
                      passwordVisible ? (
                        <EyeIcon className="size-5" onClick={() => setPasswordVisible(!passwordVisible)} />
                      ) : (
                        <EyeSlashIcon className="size-5" onClick={() => setPasswordVisible(!passwordVisible)} />
                      )
                    }
                    onChange={(e) => {
                      setFieldValue("password", e.target.value);
                    }}
                    errors={touched["password"] ? errors : {}}
                  />

                  <div className={"text-right"}>
                    <button
                      type="button"
                      className={
                        "text-primary text-center font-semibold text-base transition-opacity active:opacity-50"
                      }
                      onClick={() => navigate("/forgot-password")}
                    >
                      {t("inputFieldsTitle.forgotPassword")}
                    </button>
                  </div>

                  <TwButton
                    variant={"secondary"}
                    // onClick={submitForm}
                    disabled={loadingReduxState.actionLoading || isSubmitting}
                    actionLoading={(loadingReduxState.actionLoading)}
                    className="w-full xs:text-base sm:text-xl md:py-3.5 mt-2.5"
                    type="submit"
                  >
                    {t("inputFieldsTitle.continue")}
                  </TwButton>
                  <div className="relative flex py-4 items-center">
                    <div className="flex-grow border-t border-gray-300"></div>
                    <span className="flex-shrink mx-4 text-gray-500 text-sm">{t("linkDescription.orContinueWith")}</span>
                    <div className="flex-grow border-t border-gray-300"></div>
                  </div>
                  <button
                    type="button"
                    className="!p-0 xs:text-base sm:text-xl"
                    onClick={googleLogin}
                  >
                    <div className="w-full flex justify-center items-center rounded-lg  border border-[#e2e8f0] p-3 cursor-pointer w-full">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="26px" height="26px"><linearGradient id="95yY7w43Oj6n2vH63j6HJb" x1="29.401" x2="29.401" y1="4.064" y2="106.734" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#ff5840"></stop><stop offset=".007" stopColor="#ff5840"></stop><stop offset=".989" stopColor="#fa528c"></stop><stop offset="1" stopColor="#fa528c"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJb)" d="M47.46,15.5l-1.37,1.48c-1.34,1.44-3.5,1.67-5.15,0.6c-2.71-1.75-6.43-3.13-11-2.37	c-4.94,0.83-9.17,3.85-11.64, 7.97l-8.03-6.08C14.99,9.82,23.2,5,32.5,5c5,0,9.94,1.56,14.27,4.46	C48.81,10.83,49.13,13.71,47.46,15.5z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJc" x1="12.148" x2="12.148" y1=".872" y2="47.812" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#feaa53"></stop><stop offset=".612" stopColor="#ffcd49"></stop><stop offset="1" stopColor="#ffde44"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJc)" d="M16.01,30.91c-0.09,2.47,0.37,4.83,1.27,6.96l-8.21,6.05c-1.35-2.51-2.3-5.28-2.75-8.22	c-1.06-6.88,0.54-13.38, 3.95-18.6l8.03,6.08C16.93,25.47,16.1,28.11,16.01,30.91z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJd" x1="29.76" x2="29.76" y1="32.149" y2="-6.939" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#42d778"></stop><stop offset=".428" stopColor="#3dca76"></stop><stop offset="1" stopColor="#34b171"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJd)" d="M50.45,51.28c-4.55,4.07-10.61,6.57-17.36,6.71C22.91,58.2,13.66,52.53,9.07,43.92l8.21-6.05	C19.78,43.81, 25.67,48,32.5,48c3.94,0,7.52-1.28,10.33-3.44L50.45,51.28z"></path><linearGradient id="95yY7w43Oj6n2vH63j6HJe" x1="46" x2="46" y1="3.638" y2="35.593" gradientTransform="matrix(1 0 0 -1 0 66)" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#155cde"></stop><stop offset=".278" stopColor="#1f7fe5"></stop><stop offset=".569" stopColor="#279ceb"></stop><stop offset=".82" stopColor="#2cafef"></stop><stop offset="1" stopColor="#2eb5f0"></stop></linearGradient><path fill="url(#95yY7w43Oj6n2vH63j6HJe)" d="M59,31.97c0.01,7.73-3.26,14.58-8.55,19.31l-7.62-6.72c2.1-1.61,3.77-3.71,4.84-6.15 c0.29-0.66-0.2-1.41-0.92-1.41H37c-2.21,0-4-1.79-4-4v-2c0-2.21,1.79-4,4-4h17C56.75,27,59,29.22,59,31.97z"></path></svg>
                      <span className="flex-shrink mx-4 [text-[#2F80ED]]">{t("inputFieldsTitle.continueWithGoogle")}</span>
                    </div>
                  </button>
                  <p className={"text-sm text-center"}>
                    {t("linkDescription.signUpLine")}{" "}
                    <button
                      className={
                        "text-primary font-bold transition-opacity active:opacity-50"
                      }
                      onClick={() => navigate("/signup")}
                    >
                      {t("account.signUp")}
                    </button>
                  </p>
                </div>
              </Form>
            )}
          </Formik>

        </div>)}
      </div>
    </TwMainLayout>)
}
